import React, { useState } from "react";

import { Theme } from "@material-ui/core/styles";
// @ts-ignore
import { useTheme } from "@material-ui/core/styles";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import WidgetDeleteContainer from "./widget-delete-container";
import WidgetDetailContainer from "./widget-detail-container";
import WidgetUpdateContainer from "./widget-update-container";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Layout } from "react-grid-layout";
// @ts-ignore
import { utils } from "react-grid-layout";

import WidgetGrid from "./widget-grid";

interface Props {
  readonly?: boolean;
  arrayHelpers?: any;
  entity?: any; // TODO could be replaced by fields (arrayHelpers.value);
  onSuccess?: any;
  onError?: any;
  fields?: any[];
}

function WidgetGridContainer(props: Props) {
  const { readonly } = props;

  const { arrayHelpers } = props;

  const theme = useTheme() as Theme;
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [openViewEntity, setOpenViewEntity] = useState(null as any);
  const [openEditEntity, setOpenEditEntity] = useState(null as any);
  const [openDeleteEntity, setOpenDeleteEntity] = useState(null as any);

  function handleView(value: any, event?: any) {
    if (event) {
      event.stopPropagation();
    }
    setOpenViewEntity(value);
  }
  function handleViewClose() {
    setOpenViewEntity(null);
  }
  function handleEdit(value: any, event?: any) {
    if (event) {
      event.stopPropagation();
    }
    setOpenEditEntity(value);
  }
  function handleEditClose() {
    setOpenEditEntity(null);
  }
  function handleDelete(value: any, event?: any) {
    if (event) {
      event.stopPropagation();
    }
    setOpenDeleteEntity(value);
  }
  function handleDeleteClose() {
    setOpenDeleteEntity(null);
  }
  const [variables, setVariables] = useState({});

  const { entity, fields = [] } = props;

  const data = fields;
  const loading = false;
  const dataSource = fields ? fields : entity ? entity.widgets : undefined;
  const totalElements = dataSource ? dataSource.length : 0;
  function changeVariables(newVariables: any) {
    if (JSON.stringify(variables) !== JSON.stringify(newVariables)) {
      setVariables(newVariables);
    }
  }
  function onLayoutChange(
    currentLayout: Layout[] /*, allLayouts: {[key: $Keys<breakpoints>]: Layout*/
  ) {
    const sorted = utils.sortLayoutItems(currentLayout, "vertical");
    // console.log("sorted layout", currentLayout, sorted);
    // TODO consider arrayHelpers.forEach... and find layout inside
    if (!readonly && onLayoutChange) {
      const different = [] as number[];
      const mapped = sorted.map((layout: Layout, layoutIndex: number) => {
        // console.log('onLayoutChange layout id: ', layout.i);

        // TODO using index as id fallback is dangerous, because the index might be an int (like Node)! => use optimistic response to ensure all widgets have an id?
        let index = dataSource.findIndex((v: any) => `${v.id}` === layout.i);
        // console.log('index: ', index);
        if (index < 0 && layout.i) {
          index = parseInt(layout.i, 10);
          // console.log('fallback index: ', index);
        }
        // console.log('onLayoutChange layout: ', layout, dataSource[index].title);

        // TODO If not arrayHelpers??
        const cloned = { ...dataSource[index] };
        cloned.layout = {
          x: layout.x,
          y: layout.y,
          width: layout.w,
          height: layout.h,
          minWidth: layout.minW || undefined,
          maxWidth: layout.maxW || undefined,
          minHeight: layout.minH || undefined,
          maxHeight: layout.maxH || undefined,
        };

        if (arrayHelpers) {
          // arrayHelpers.update(index, cloned);
          if (index !== layoutIndex) {
            // console.log("moving widget from ", index, "to", layoutIndex);
            // console.log("fields before", arrayHelpers);
            // arrayHelpers.move(index, layoutIndex);
            // console.log("fields after", arrayHelpers);
            // // arrayHelpers.remove(index);
            // // arrayHelpers.insert(layoutIndex, cloned);
            different.push(index);
          }
        }
        return cloned;
      });
      if (arrayHelpers /*&& different.length > 0*/) {
        // Delete all
        mapped.forEach((it: any) => arrayHelpers.pop());
        // console.log("after pop", arrayHelpers);
        // Add all
        mapped.forEach((it: any) => arrayHelpers.push(it));
        // console.log("after push", arrayHelpers);
      }
    }
  }
  return (
    <>
      {data && dataSource && (
        <WidgetGrid
          dataSource={dataSource}
          totalElements={totalElements}
          changeVariables={changeVariables}
          loading={loading}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDelete}
          readonly={readonly}
          onLayoutChange={onLayoutChange}
        ></WidgetGrid>
      )}
      <Dialog
        fullScreen={fullScreen}
        open={openViewEntity !== null}
        onClose={handleViewClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Widget</DialogTitle>
        <DialogContent>
          <WidgetDetailContainer
            entity={openViewEntity}
            // fields={fields}
            // arrayHelpers={arrayHelpers}
            // onClose={handleViewClose}
            // onSuccess={handleViewClose} // TODO reload window?
          />
        </DialogContent>
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        open={openEditEntity !== null}
        onClose={handleEditClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Update Widget</DialogTitle>
        <DialogContent>
          <WidgetUpdateContainer
            entity={openEditEntity}
            fields={fields}
            arrayHelpers={arrayHelpers}
            onClose={handleEditClose}
            onSuccess={handleEditClose} // TODO reload window?
          />
        </DialogContent>
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        open={openDeleteEntity !== null}
        onClose={handleDeleteClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Delete Widget</DialogTitle>
        <DialogContent>
          <WidgetDeleteContainer
            entity={openDeleteEntity}
            fields={fields}
            onClose={handleDeleteClose}
            onSuccess={handleDeleteClose} // TODO reload window?
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default WidgetGridContainer;
